import { useEffect, useState } from 'react';

const MAX_MOBILE_WIDTH = 768;
const MIN_TABLET_WIDTH = 769;
const MAX_TABLET_WIDTH = 1279;

const MOBILE_IDENTIFIERS = [
  'iphone',
  'ipad',
  'blackberry',
  'hammertwa',
];

const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  return (
    MOBILE_IDENTIFIERS.some((identifier) => userAgent.includes(identifier))
    || window.innerWidth <= MAX_MOBILE_WIDTH
  );
};

const isTabletDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth >= MIN_TABLET_WIDTH && window.innerWidth <= MAX_TABLET_WIDTH;
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const [isTablet, setIsTablet] = useState(isTabletDevice());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleResize = () => {
      setIsMobile(isMobileDevice());
      setIsTablet(isTabletDevice());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, isTablet };
};

export default useIsMobile;
